import React, { useEffect, useRef, useState } from "react";
import { API } from "../lib/api";

/** Plays back a stored recitation by attempt_id using token-as-query-param. */
export default function RecitationAudioPlayer({ attemptId, className = "", testid = "audio-player" }) {
  const [error, setError] = useState(false);
  const audioRef = useRef(null);

  if (!attemptId) return null;
  const src = `${API}/recitation/audio/${attemptId}`;

  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid={testid}>
      <audio
        ref={audioRef}
        src={src}
        controls
        preload="metadata"
        onError={() => setError(true)}
        className="w-full h-9"
      />
      {error && <span className="text-xs text-terracotta-600">Audio unavailable</span>}
    </div>
  );
}
